module.exports = __webpack_public_path__ + "img/45-green.5d21eae2.svg";